let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("76n7a"), load("l253H"), load("eXPra")]).then(() => parcelRequire('8nMC7'));